<button class="btn border-0 px-0 h-100 w-100" (click)="toggleLanguage()">
  <h1 [ngClass]="{ 'text-end': translate.currentLang === 'ar', 'text-start': translate.currentLang !== 'ar' }" class="px-0 main-color">
    <img src="assets/images/Language.svg" class="tw-size-5 d-inline-block" alt="">
    {{ Language }}
  </h1>
</button>